import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { requestPasswordReset } from "../lib/auth";
import { Logo } from "../components/Logo";
import { AigenticoBadge } from "../components/AigenticoBadge";

export function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await requestPasswordReset(email);
      nav("/forgot/confirm", { state: { email } });
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-6">
        <div className="flex items-center justify-between gap-4">
          <Link to="/"><Logo /></Link>
          <a href="https://aigentico.ai" target="_blank" rel="noopener" title="An Aigentico product — visit Aigentico" className="shrink-0">
            <AigenticoBadge size={32} />
          </a>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-6">
          <div>
            <h2 className="mb-2">Reset your password</h2>
            <p className="text-ink-soft text-sm">
              Enter your email. We will send a 6-digit code so you can choose a new password.
            </p>
          </div>

          <div>
            <label className="label" htmlFor="email">Email</label>
            <input
              id="email" type="email" autoComplete="email" required
              className="input" value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          {error && (
            <div className="text-aigentico-red text-sm border border-aigentico-red bg-white px-4 py-3 rounded-md">
              {error}
            </div>
          )}

          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? "Sending code…" : "Send reset code"}
          </button>

          <div className="text-center text-sm">
            <Link to="/signin" className="text-aigentico-navy hover:underline">Back to sign in</Link>
          </div>
        </form>
      </main>
    </div>
  );
}
